// A custom hook that builds on useLocation to parse
// the query string for you.
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * @description Хук для получения и мемоизации параметров URL-запроса.
 *              Использует useMemo, чтобы возвращать стабильный объект URLSearchParams,
 *              предотвращая лишние ререндеры в дочерних компонентах.
 * @returns {URLSearchParams} Мемоизированный объект URLSearchParams.
 */
export const useUrlQuery = (): URLSearchParams => {
	const { search } = useLocation();

	// Мемоизируем экземпляр URLSearchParams.
	// Он будет пересоздаваться только когда строка `search` действительно изменится.
	return useMemo(() => {
		// log.debug("Recalculating URLSearchParams because search string changed to: %s", search);
		return new URLSearchParams(search);
	}, [search]);
};
